import RestClient from './rest-client'

export default class Docs extends RestClient {
  static get url () {
    return this.apiUrl.split('/v1')[0] + '/docs'
  }
  
  static get paramKey () {
    return 'docs'
  }

  static async getPartnersApiDoc () {
    const { data } = await this.http({
      url: this.url + '/partners',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return data
  }
}